
import React, { Component } from "react";
import "../css/deliveryAreas.css";
import { getLocale, getLocale2 } from "../js/auth";
import { I18n } from "react-redux-i18n";
if (typeof localStorage.bookingMapZoom === "undefined") {
    localStorage.bookingMapZoom = 13;
}


class DeliveryAreas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0
        };
    }

    componentWillUnmount() {
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }



    handleDeleteArea = (id, baseLabel) => {
        const item =  this.props.items.find(item => item.index === id);
        item.onDropIndexClick(id)();
    };

    render() {
        const { items, onAddClick, schema } = this.props;
        const { activeTab } = this.state;
        return (
            <div className="home-delivery-area-editor">
                {/* Display array field name and description */}
                {schema && (
                    <div className="delivery-area-schema-header">
                        {schema.title && <h3>{schema.title}</h3>}
                        {schema.description && <p className="text-muted">{schema.description}</p>}
                    </div>
                )}
                <div className="delivery-area-tabs">
                    {items.map((item, index) => {
                        let baseLabel = item.label || `Area ${index + 1}`;
                        let postfix = (getLocale(item.children.props.formData.name)) ? ` (${getLocale(item.children.props.formData.name)})` : '';
                        return (
                            <button
                                key={item.index}
                                className={"delivery-area-tab" + (activeTab === index ? " active" : "")}
                                onClick={() => this.setState({ activeTab: index })}
                                type="button"
                            >
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {postfix || baseLabel}
                                    <span
                                        style={{
                                            marginLeft: 8,
                                            color: '#f44336',
                                            cursor: 'pointer',
                                            fontWeight: 'bold',
                                            fontSize: '1.1em',
                                            lineHeight: 1,
                                        }}
                                        title="Delete area"
                                        onClick={e => {
                                            e.stopPropagation();
                                            this.handleDeleteArea(item.index, baseLabel);
                                        }}
                                    >
                                        ×
                                    </span>
                                </span>
                            </button>
                        );
                    })}
                    <button style={{ position: "sticky", right: 0}} type="button" onClick={onAddClick} className="btn btn-info btn-add col-xs-12" tabIndex="0"><i className="glyphicon glyphicon-plus"></i></button>
                </div>
                <div className="delivery-area-tab-content">
                    {items[activeTab] && (
                        <div className="delivery-area-item">
                            {items[activeTab].children}
                        </div>
                    )}
                </div>
            </div>
        );
    }

}



export default DeliveryAreas;